var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "richtext-input" }, [
    !_vm.disableEdit
      ? _c(
          "div",
          { staticStyle: { border: "1px solid #ccc" } },
          [
            _c("Toolbar", {
              staticStyle: { "border-bottom": "1px solid #ccc" },
              attrs: {
                editor: _vm.editor,
                defaultConfig: _vm.toolbarConfig,
                mode: _vm.mode,
              },
            }),
            _c("Editor", {
              staticStyle: {
                height: "300px",
                "overflow-y": "hidden",
                resize: "vertical",
              },
              attrs: { defaultConfig: _vm.editorConfig, mode: _vm.mode },
              on: { onCreated: _vm.onCreated },
              model: {
                value: _vm.hereValue,
                callback: function ($$v) {
                  _vm.hereValue = $$v
                },
                expression: "hereValue",
              },
            }),
          ],
          1
        )
      : _c("div", { domProps: { innerHTML: _vm._s(_vm.value) } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }